<template>
  <el-container class="default-layout">
    <el-container>

      <main class="container">
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">4</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <span class="particle">0</span>
        <article class="content">

            <div class="not-found-page">
              <figure>
                <div class="sad-mac"></div>
                <figcaption>
                  <span class="sad-mac--text">Error 404: Not Found</span>
                  <span class="e"></span>
                  <span class="r"></span>
                  <span class="r"></span>
                  <span class="o"></span>
                  <span class="r"></span>
                  <span class="_4"></span>
                  <span class="_0"></span>
                  <span class="_4"></span>
                  <span class="n"></span>
                  <span class="o"></span>
                  <span class="t"></span>
                  <span class="f"></span>
                  <span class="o"></span>
                  <span class="u"></span>
                  <span class="n"></span>
                  <span class="d"></span>
                </figcaption>
              </figure>
              <div class="not-found-page__action">
                <el-button type="primary" size="mini" @click="goBack">Назад</el-button>
              </div>
          </div>
        </article>
      </main>

    </el-container>
  </el-container>
</template>



<script>
export default {
  name: "NotFound",
  methods: {
    goBack() {
      this.$router.push({name: 'cpanel.dashboard'});
    }
  },
  created() {
    document.title = '404 - не найдено'
  }
}
</script>

<style scoped lang="scss">
.not-found-background {
  height: 100vh;
  width: 100vw;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  background: #ececec;
}

.not-found-page {
  max-width: 600px;
  margin: auto;
  padding: 15px;
  box-shadow: 0 0 51px 0 #fff;

  border-radius: 6px;
  text-align: center;

  &__title {
    margin-bottom: 25px;
    font-size: 100px;
  }
  &__action{
    margin-top: 50px;
  }
}


figure {
  font-size: 6px;
  margin: 0 auto;

  width: 64em;
}
figcaption {
  color: #ccc;
  display: flex;
  align-content: space-between;
  flex-wrap: wrap;
  height: 17em;
}
figcaption span:before, .sad-mac:before {
  content: "";
  display: block;
  width: 1em;
  height: 1em;
  transform: translate(-1em,-1em);
}
figcaption span {
  display: inline-block;
  margin: 0 2em;
  width: 4em;
  height: 6em;
}

.sad-mac {
  margin: 0 auto 7em auto;
  width: 23em;
  height: 30em;
  color: #444;

  &--text {
    overflow: hidden;
    position: absolute;
    width: 0;
    height: 0;
  }

}
.sad-mac:before {
  box-shadow: 1em 1em, 23em 1em, 4em 3em, 5em 3em, 6em 3em, 7em 3em, 8em 3em, 9em 3em, 10em 3em, 11em 3em, 12em 3em, 13em 3em, 14em 3em, 15em 3em, 16em 3em, 17em 3em, 18em 3em, 19em 3em, 20em 3em, 3em 4em, 21em 4em, 3em 5em, 21em 5em, 3em 6em, 7em 6em, 9em 6em, 15em 6em, 17em 6em, 21em 6em, 3em 7em, 8em 7em, 16em 7em, 21em 7em, 3em 8em, 7em 8em, 9em 8em, 15em 8em, 17em 8em, 21em 8em, 3em 9em, 21em 9em, 3em 10em, 10em 10em, 13em 10em, 21em 10em, 3em 11em, 11em 11em, 12em 11em, 21em 11em, 3em 12em, 21em 12em, 3em 13em, 10em 13em, 11em 13em, 12em 13em, 13em 13em, 14em 13em, 21em 13em, 3em 14em, 9em 14em, 15em 14em, 16em 14em, 21em 14em, 3em 15em, 17em 15em, 21em 15em, 3em 16em, 21em 16em, 4em 17em, 5em 17em, 6em 17em, 7em 17em, 8em 17em, 9em 17em, 10em 17em, 11em 17em, 12em 17em, 13em 17em, 14em 17em, 15em 17em, 16em 17em, 17em 17em, 18em 17em, 19em 17em, 20em 17em, 3em 22em, 4em 22em, 5em 22em, 14em 22em, 15em 22em, 16em 22em, 17em 22em, 18em 22em, 19em 22em, 20em 22em, 1em 27em, 2em 27em, 3em 27em, 4em 27em, 5em 27em, 6em 27em, 7em 27em, 8em 27em, 9em 27em, 10em 27em, 11em 27em, 12em 27em, 13em 27em, 14em 27em, 15em 27em, 16em 27em, 17em 27em, 18em 27em, 19em 27em, 20em 27em, 21em 27em, 22em 27em, 23em 27em, 1em 28em, 23em 28em, 1em 29em, 23em 29em, 1em 30em, 23em 30em;
}
/* 2. Letters */
._0:before {
  box-shadow: 2em 1em, 3em 1em, 1em 2em, 1em 3em, 1em 4em, 1em 5em, 4em 2em, 4em 3em, 4em 4em, 4em 5em, 2em 4em, 3em 3em, 2em 6em, 3em 6em;
}
._4:before {
  box-shadow: 1em 1em, 1em 2em, 1em 3em, 1em 4em, 4em 1em, 4em 2em, 4em 3em, 4em 4em, 2em 4em, 3em 4em, 4em 5em, 4em 6em;
}
.d:before {
  box-shadow: 1em 1em, 2em 1em, 3em 1em, 1em 2em, 4em 2em, 1em 3em, 4em 3em, 1em 4em, 4em 4em, 1em 5em, 4em 5em, 1em 6em, 2em 6em, 3em 6em;
}
.e:before {
  box-shadow: 1em 1em, 2em 1em, 3em 1em, 4em 1em, 1em 2em, 1em 3em, 2em 3em, 3em 3em, 1em 4em, 1em 5em, 1em 6em, 2em 6em, 3em 6em, 4em 6em;
}
.f:before {
  box-shadow: 1em 1em, 2em 1em, 3em 1em, 4em 1em, 1em 2em, 1em 3em, 2em 3em, 3em 3em, 1em 4em, 1em 5em, 1em 6em;
}
.n:before {
  box-shadow: 1em 1em, 1em 2em, 1em 3em, 1em 4em, 1em 5em, 1em 6em, 4em 1em, 4em 2em, 4em 3em, 4em 4em, 4em 5em, 4em 6em, 2em 3em, 3em 4em;
}
.o:before {
  box-shadow: 2em 1em, 3em 1em, 1em 2em, 1em 3em, 1em 4em, 1em 5em, 4em 2em, 4em 3em, 4em 4em, 4em 5em, 2em 6em, 3em 6em;
}
.r:before {
  box-shadow: 1em 1em, 2em 1em, 3em 1em, 4em 2em, 1em 2em, 1em 3em, 1em 4em, 2em 3em, 3em 3em, 1em 5em, 1em 6em, 4em 4em, 4em 5em, 4em 6em;
}
.t:before {
  box-shadow: 1em 1em, 2em 1em, 3em 1em, 2em 2em, 2em 3em, 2em 4em, 2em 5em, 2em 6em;
}
.u:before {
  box-shadow: 1em 1em, 1em 2em, 1em 3em, 1em 4em, 1em 5em, 4em 1em, 4em 2em, 4em 3em, 4em 4em, 4em 5em, 2em 6em, 3em 6em;
}

@media screen and (max-width: 410px) {
  figure {
    font-size: 20%;
  }
}@media screen and (min-width: 720px) {
  figure {
    font-size: 7px;
  }
}
@media screen and (min-width: 1440px) {
  figure {
    font-size: 8px;
  }
}



$anims: float, floatReverse,float2, floatReverse2;
$easeSmooth: cubic-bezier(0.39,0.575,0.28,0.995);
$color: #595959;

.container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: white;
  color: black;
  font-family: arial, sans-serif;
  overflow: hidden;
  width: 100%;
}
.content {
  position: relative;
  width: 600px;
  max-width: 100%;
  margin: 20px;
  background: white;
  padding: 60px 40px;
  text-align: center;
  box-shadow: -10px 10px 67px -12px rgba(0,0,0,0.2);
  opacity: 0;
  animation: apparition 0.8s 1.2s $easeSmooth forwards;
  z-index: 9;

  p {
    font-size: 1.3rem;
    margin-top: 0;
    margin-bottom: 0.6rem;
    letter-spacing: 0.1rem;
    color: $color;
    &:last-child{margin-bottom: 0;}
  }

}

.particle {
  position: absolute;
  display: block;
  pointer-events: none;

  @for $i from 1 through 80 {
    &:nth-child(#{$i}){
      $size: random(20) + 10;
      $blur: $i * 0.02;
      $speed: random(20)+20;
      $delay: random(10)*0.1;
      $anim: nth($anims, random(length($anims)));

      top: random(100) / (100 + $size/8) * 100%;
      left: random(100) / (100 + $size/10) * 100%;
      font-size: $size + px;
      filter: blur( (#{$blur}) + px);
      animation: $speed+s  $anim infinite;

      z-index: 5;
      color: #ccc;
    }
  }
}

@keyframes apparition {
  from {
    opacity: 0;
    transform: translateY(100px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%,100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(180px);
  }
}

@keyframes floatReverse {
  0%,100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-180px);
  }
}

@keyframes float2 {
  0%,100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(28px);
  }
}

@keyframes floatReverse2 {
  0%,100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-28px);
  }
}

@mixin animation ($delay, $duration, $animation) {
  animation-delay: $delay;
  animation-duration: $duration;
  animation-name: $animation;
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}
</style>